import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/subscriptions/{stripeAccountId}/{subscriptionId}';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getUserSubscriptionStripe = async ({ stripeAccountId, subscriptionId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { stripeAccountId, subscriptionId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getUserSubscriptionStripe;
